export const getEnvVariables = () => {
    return {
        ...process.env,
        authDomain: process.env.REACT_APP_AUTH_DOMAIN as string,
        authClientId: process.env.REACT_APP_AUTH_CLIENT_ID as string,
        authAudience: process.env.REACT_APP_AUTH_AUDIENCE as string,
        rootUrl: process.env.REACT_APP_ROOT_URL as string,
        apiRootUrl: process.env.REACT_APP_API_ROOT_URL as string,
    }
}